var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-open-message-configure"},[_c('el-tabs',{attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"类目模板","lazy":""}},[_c('WxOpenMessageConfigurePub')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"个人模板","lazy":""}},[_c('WxOpenMessageConfigureTpl')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }